import React, { useEffect } from 'react';
import PropTypes, { func } from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Container, Card, CardHeader, CardTitle, CardBody, ButtonGroup, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import PageWrapper from '../../../components/Content/PageWrapper';
import CmsPanel from '../../Cms/components/content/CmsPanel';

function ErrorPage({ dispatch, intl }) {
    return (
        <Container className="page-wrapper bg-company">
            <PageWrapper>
                <Card className="mt-5 mb-5 shadow text-center">
                    <CardHeader>
                        <CardTitle>
                            <FontAwesome name="exclamation-triangle" /> <FormattedMessage id="appBackHomeTitle" defaultMessage="Wrong Way..." />
                        </CardTitle>
                    </CardHeader>
                    <CardBody className="px-3">

						<CmsPanel slug="info-404" defaultDisplay={<FormattedMessage id="app404ErrorText" defaultMessage="We didn't find what you're looking for! Go back to homepage or your account" />} />
                        <ButtonGroup className="d-block mt-3">
                            <Button tag={Link} to="/" color="secondary" outline><FontAwesome name="home" /> <FormattedMessage id="appBackHomeButton" defaultMessage="Back home" /></Button>
                            <Button tag={Link} to="/user/profile" color="primary" outline><FontAwesome name="user-circle" /> <FormattedMessage id="userAccountMy" defaultMessage="My account" /></Button>
                        </ButtonGroup>
                    </CardBody>
                </Card>
            </PageWrapper>
        </Container>
    );
}

function mapStateToProps(store, props) {
    return {
    };
}

ErrorPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(injectIntl(ErrorPage));
